(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('ozwilloCreateinstance', ozwilloCreateinstance);

    function ozwilloCreateinstance(swif) {
        'ngInject';
        return {
            restrict: 'E',
            require:'ngModel',
            scope: {},
            template: '<button class="btn btn-default" ng-click="dispatch()">Notify ozwillo instance is created</button>',
            link: function(scope, element, attr, ngModel) {
                scope.dispatch = function () {
                    var args = [ngModel.$viewValue.id];
                    swif.data.callKw(
                        'intervention_request',
                        'createinstance',
                        args,
                        {}
                    );
                };
            }
        };
    }

})();
